import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { useApp } from "../context/AppContext";
import { pageContent } from "../pageContent";

const StaticPage = () => {
  const { slug } = useParams();
  const { t } = useApp();
  const page = pageContent[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!page) {
    return (
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-24 text-center fade-up">
        <h1 className="font-serif-lux text-4xl text-[#1b1b1b]">Page introuvable</h1>
        <Link to="/" className="inline-block mt-6 text-sm text-[#b08d57] underline">{t("home")}</Link>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-10 md:py-14 fade-up" data-testid={`static-page-${slug}`}>
      <div className="flex items-center gap-1.5 text-xs text-muted-foreground mb-6">
        <Link to="/" className="hover:text-[#b08d57]">{t("home")}</Link>
        <ChevronRight className="h-3 w-3" />
        <span className="text-[#1b1b1b]">{page.title}</span>
      </div>

      <div className="h-px w-10 bg-[#b08d57] mb-5" />
      <h1 className="font-serif-lux text-4xl md:text-5xl text-[#1b1b1b]">{page.title}</h1>
      {page.intro && <p className="text-[15px] text-[#555] mt-4 leading-relaxed max-w-2xl">{page.intro}</p>}

      <div className="mt-10 space-y-9">
        {page.sections.map((s, i) => (
          <section key={i}>
            <h2 className="font-serif-lux text-xl md:text-2xl text-[#1b1b1b]">{s.h}</h2>
            <div className="mt-2.5 space-y-2">
              {s.body.map((p, j) => (
                <p key={j} className="text-[15px] text-[#444] leading-relaxed">{p}</p>
              ))}
            </div>
          </section>
        ))}
      </div>

      <div className="mt-14 border-t border-border pt-6 text-sm text-muted-foreground">
        Une question ? <a href="mailto:contact@amourduluxe.com" className="text-[#b08d57] hover:underline">contact@amourduluxe.com</a>
      </div>
    </div>
  );
};

export default StaticPage;
